import { getDeveloperApi } from '@squareup/dex-data-shared-developer-api';
import { useSelectSpecVersionInView } from '@squareup/dex-tech-store-access-selectors';
import { useParams } from '@squareup/dex-utils-shared-routing-hooks';

const useSelectSpecVersionMetadata = () => {
  const { square_version } = useParams();
  const { parsedInfo } = useSelectSpecVersionInView();

  const { data: versions } =
    getDeveloperApi().useGetSpecificationVersionsQuery(undefined);

  const selectedVersion = parsedInfo?.version || '';
  const latestVersion = versions?.at(0);
  const selectedVersionMatchesLatestVersion =
    Boolean(selectedVersion) &&
    Boolean(latestVersion) &&
    selectedVersion === latestVersion;

  // Because the `useGetSpecificationVersionsQuery` happens after the first render,
  // the `selectedVersionMatchesLatestVersion` will be false until the query is complete.
  // So as a shortcut for SSR concerns, we can also just check for the existence of the version part of the `square_version` query parameter, since
  // the lack of it means we're looking at the latest version.
  const hasVersionParam =
    typeof square_version === 'string' && Boolean(square_version.split('_')[1]);

  const isVersionSelectionLatest =
    !hasVersionParam || selectedVersionMatchesLatestVersion;

  return {
    isVersionSelectionLatest,
  };
};

export { useSelectSpecVersionMetadata };
